import {createSelector} from 'reselect'
import {State} from 'lib/store'
import {PreviewState} from './reducer'

const selectFeature = (state: State): PreviewState => state.preview

export const getRows = (name: string) => createSelector(selectFeature, state => state[name] ? state[name].rows : [])
